import { render } from "./DeleteEventoModal.vue?vue&type=template&id=a47eb160"
import script from "./DeleteEventoModal.vue?vue&type=script&lang=js"
export * from "./DeleteEventoModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__